/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { NotInKeyTypeValuesItem } from './NotInKeyTypeValuesItem';

export const NotInKeyType: core.serialization.ObjectSchema<serializers.NotInKeyType.Raw, Truvity.NotInKeyType> =
    core.serialization.object({
        values: core.serialization.list(NotInKeyTypeValuesItem),
    });

export declare namespace NotInKeyType {
    export interface Raw {
        values: NotInKeyTypeValuesItem.Raw[];
    }
}
